// DeviceModal.js
import React, { useRef, useState } from "react";
import * as PR from "../../prime-modules/index";
import { Formik, Form } from "formik";
import { newDeviceValidationSchema } from "../../utils/schema";
import Input from "../../components/form/Input";
import { cancelDeviceApi, newDeviceApi, removeDeviceApi } from "../../services/api";
import { useMutation } from "react-query";
import { useToast } from "../../context/ToastContext";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment/moment";
import { ICCID } from "../../utils/localstore";
import { showDate } from "../../utils/reuse";
import ChangeSubscription from "./ChangeSubscription";
import { temporaryTranslations } from "../../assets/data/temporaryTranslations";

const ModalDialog = ({ visible, activeSection, onHide, labelsIot, currentDevice, refetch, data }) => {

  const navigate = useNavigate();
  const { state } = useLocation();
  const userData = useSelector(state => state.auth.userData);
  const formikRef = useRef(null);
  const { showToast } = useToast()
  const [cancelSuccessToast, setCancelSuccessToast] = useState('')
  const [deleteDeviceSuccessToast, setDeleteDeviceSuccessToast] = useState('')
  const [selectedReason, setSelectedReason] = useState(null);
  const [otherReasonText, setOtherReasonText] = useState('');

  const initialNewDevicesValues = {
    tag: "",
    simIconName: "",
    userId: "",
    iccid: state?.iccid ?? "",
    iccidPin: state?.pin ?? ""
  }

  const { mutate: newDeviceMutate, isLoading: newDeviceLoading } = useMutation(newDeviceApi, {
    onSuccess: (o) => {
      showToast("success", labelsIot?.LBLI0142)
      formikRef?.current.resetForm();
      onHide()
      refetch()
      navigate('/plans')
    },
    onError: (o) => {
      localStorage.setItem(ICCID, "")
      showToast("error", o?.message)
    }

  })

  const { mutate: removeDeviceMutate, isLoading: removeDeviceLoading } = useMutation(removeDeviceApi, {
    onSuccess: (o) => {
      setDeleteDeviceSuccessToast(labelsIot?.LBLI0143)
      setTimeout(() => {
        onHide()
        refetch()
        setDeleteDeviceSuccessToast("")
      }, 3000);
    },
    onError: (o) => showToast("error", o?.message)

  })

  const { mutate: cancelDeviceSubscription, isLoading: cancelDeviceLoading } = useMutation(cancelDeviceApi, {
    onSuccess: (o) => {
      setCancelSuccessToast(labelsIot?.LBLI0043 + " " + moment(o?.validUntil).format("DD MMM YYYY"))
      setTimeout(() => {
        onHide()
        refetch()
        setCancelSuccessToast("")
      }, 3000);
    },
    onError: (o) => showToast("error", o?.message)
  })



  const handleSelectPlan = () => {
    navigate('/plans')
  }

  const getModalContent = () => {
    switch (activeSection) {
      case 'addDevice':
        return {
          header: <h2><span className="add-icon">+</span>{labelsIot?.LBLI0020}</h2>,
          content: <div className="device-section-wrapper">
            <Formik initialValues={initialNewDevicesValues}
              validationSchema={newDeviceValidationSchema}
              onSubmit={(values) => {
                let tempPrams = { ...values }
                tempPrams.iccid = tempPrams.iccid.toString()
                tempPrams.simIconName = tempPrams.simIconName?.code
                tempPrams.userId = userData?.userId
                localStorage.setItem(ICCID, tempPrams.iccid)
                newDeviceMutate(tempPrams)
              }} innerRef={formikRef} >
              <Form autoComplete="off">

                <div className="card flex flex-column gap-2 mb-4">
                  <Input
                    label={labelsIot?.LBLI0030}
                    name="tag"
                    type="text"
                    aria-describedby="name"
                    placeholder={labelsIot?.LBLI0031}
                  />
                </div>

                {/* <div className="card flex flex-column gap-2 mb-4">
                  <Input
                        label={labelsIot?.LBLI0032}
                        name="simIconName"
                        type="option"
                        aria-describedby="type"
                        options={deviceName} 
                        optionLabel="name" 
                        className="language-dropdown" 
                        placeholder={labelsIot?.LBLI0033}
                      />
                  
                </div> */}
                <div className="card flex flex-column gap-2 mb-4">
                  <Input
                    label={labelsIot?.LBLI0034}
                    type="text"
                    maxLength="22"
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
                    }}
                    name="iccid"
                    aria-describedby="iccid"
                    placeholder={labelsIot?.LBLI0035}
                  />
                </div>
                <div className="card flex flex-column gap-2">
                  <Input
                    label={labelsIot?.LBLI0179}
                    type="text"
                    maxLength="4"
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
                    }}
                    name="iccidPin"
                    aria-describedby="iccidPin"
                    placeholder={`${labelsIot?.LBLI0179} ****`}
                  />
                </div>
                <div className="card flex flex-column">
                  <PR.Button disabled={newDeviceLoading} label={labelsIot?.LBLI0036} className="device-confirm-button" />
                </div>
              </Form>
            </Formik>
          </div>
        };
      case 'cancelSubscription':
        const reasons = [
          { label: labelsIot?.LBLI0223 || temporaryTranslations.LBLI0223, value: labelsIot?.LBLI0223 || temporaryTranslations.LBLI0223 },
          { label: labelsIot?.LBLI0224 || temporaryTranslations.LBLI0224, value: labelsIot?.LBLI0224 || temporaryTranslations.LBLI0224 },
          { label: labelsIot?.LBLI0225 || temporaryTranslations.LBLI0225, value: labelsIot?.LBLI0225 || temporaryTranslations.LBLI0225 },
          { label: labelsIot?.LBLI0226 || temporaryTranslations.LBLI0226, value: labelsIot?.LBLI0226 || temporaryTranslations.LBLI0226 },
          { label: labelsIot?.LBLI0227 || temporaryTranslations.LBLI0227, value: labelsIot?.LBLI0227 || temporaryTranslations.LBLI0227 }
        ];

        return {
          header: <h2><span><i className="pi pi-minus-circle"></i></span>{labelsIot?.LBLI0037}</h2>,
          content: <div className="cancel-subscription">
            <h3>{labelsIot?.LBLI0038}</h3>
            <p>{labelsIot?.LBLI0039}</p>
            <p className="mb-4">{labelsIot?.LBLI0040}: {labelsIot?.LBLI0041}</p>

            <div className="reason-section mb-4">
              <p className="font-bold mb-2">{labelsIot?.LBLI0222 || temporaryTranslations.LBLI0222}</p>
              {reasons.map((reason) => (
                <div key={reason.value} className="flex align-items-center mb-2">
                  <PR.RadioButton
                    inputId={reason.value}
                    name="reason"
                    value={reason.value}
                    onChange={(e) => setSelectedReason(e.value)}
                    checked={selectedReason === reason.value}
                  />
                  <label htmlFor={reason.value} className="ml-2">{reason.label}</label>
                </div>
              ))}
              {selectedReason === 'Other' && (
                <div className="mt-2">
                  <PR.InputTextarea
                    value={otherReasonText}
                    onChange={(e) => setOtherReasonText(e.target.value)}
                    rows={3}
                    className="w-full"
                    placeholder={labelsIot?.LBLI0227}
                  />
                </div>
              )}
            </div>

            <div className="card flex flex-column">
              <PR.Button
                disabled={cancelDeviceLoading || cancelSuccessToast || !selectedReason || (selectedReason === 'Other' && !otherReasonText.trim())}
                onClick={() => {
                  const finalReason = selectedReason === 'Other' ? otherReasonText : selectedReason;
                  cancelDeviceSubscription(
                    currentDevice?.orderid !== "" ? {
                      iccid: currentDevice?.iccid,
                      subscription: currentDevice?.subscriptionName,
                      orderid: currentDevice?.orderid,
                      reason: finalReason
                    } : {
                      iccid: currentDevice?.iccid,
                      subscription: currentDevice?.subscriptionName,
                      reason: finalReason
                    })
                }}
                label={labelsIot?.LBLI0042}
                className="device-confirm-button"
              />
            </div>
            {!!cancelSuccessToast && <span className="error-message">{cancelSuccessToast}</span>}
          </div>
        };
      case 'changeSubscription':
        return {
          header: <h2><span><i className="pi pi-refresh"></i></span>{labelsIot?.LBLI0202 || "Change subscription"}</h2>,
          content: (<ChangeSubscription
            labelsIot={labelsIot}
            currentDevice={currentDevice}
            data={data}
            onHide={onHide}
            refetch={refetch} />)
        };
      case 'renewSubscription':
        return {
          header: <h2><span><i className="pi pi-refresh"></i></span>{labelsIot?.LBLI0044}</h2>,
          content: <div className="renew-subscription">
            <p>{labelsIot?.LBLI0045} {showDate(data.find(item => item.iccid === localStorage.getItem(ICCID))?.subscriptionNextDue)}. <br /> {labelsIot?.LBLI0046}</p>
            <div className="card flex flex-column">
              <PR.Button onClick={handleSelectPlan} label={labelsIot?.LBLI0047} className="device-confirm-button" />
            </div>
          </div>
        };
      case 'removeDevice':
        return {
          header: <h2><span><i className="pi pi-trash"></i></span>{labelsIot?.LBLI0048}</h2>,
          content: <div className="cancel-subscription">
            <h3>{labelsIot?.LBLI0049} ({currentDevice?.iccid}) </h3>
            <p style={{ fontSize: 14, color: "red" }}>{labelsIot?.LBLI0221 || "Note: This does not remove the SIM from your profile, it simply hides it from the devices list."}</p>
            <div className="card flex flex-column">
              <PR.Button disabled={removeDeviceLoading || deleteDeviceSuccessToast} onClick={() => removeDeviceMutate(currentDevice.iccid)} label={labelsIot?.LBLI0050} className="device-confirm-button" />
            </div>
            {!!deleteDeviceSuccessToast && <span className="error-message">{deleteDeviceSuccessToast}</span>}
          </div>
        };
      default:
        return { header: null, content: null };
    }
  };

  const { header, content } = getModalContent();

  return (
    <PR.Dialog visible={visible} modal draggable={false} header={header} onHide={onHide} closeOnEscape={false} maskClassName="add-device-dialog">
      <div className="modal-content">{content}</div>
    </PR.Dialog>
  );
};

export default ModalDialog;